module.exports = __webpack_public_path__ + "img/20190916170440360截图20190916145943245.9614d1a5.jpg";